import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '',
      redirect: '/district/teams',
      name: 'root',
    },
    {
      path: '/:abbreviation',
      component: () =>
        import(
          /* webpackChunkName: "chunk-search" */ '@/pages/Asd20DirectorySearchPage.vue'
        ),
      props: true,
      children: [
        {
          path: 'people',
          name: 'people',
          component: () =>
            import(
              /* webpackChunkName: "chunk-people" */ '@/pages/Asd20DirectoryPeopleResultsPage.vue'
            ),
        },
        {
          path: 'teams',
          name: 'teams',
          component: () =>
            import(
              /* webpackChunkName: "chunk-teams" */ '@/pages/Asd20DirectoryGroupResultsPage.vue'
            ),
        },
        {
          path: 'teams/:slug',
          name: 'team',
          component: () =>
            import(
              /* webpackChunkName: "chunk-teams" */ '@/pages/Asd20DirectoryGroupResultsPage.vue'
            ),
          props: true,
        },
      ],
    },
    // {
    //   path: '/',
    //   // redirect: 'people',
    //   name: 'search',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "chunk-search" */ '@/pages/Asd20DirectorySearchPage.vue'
    //     ),

    // },
  ],
})
